import { useState, useCallback } from "react";

export const DIALOGS = {
  LEDGER: "ledger",
  DISCONNECTS: "disconnects",
  WORK_ORDERS: "workOrders",
  ACCOUNT_FILES: "accountFiles",
  METER_READINGS: "meterReadings",
  USER_PROFILE: "userProfile",
  CONTACT_ACCOUNT_HOLDER: "contactAccountHolder",
  AR_RECEIPTS: "arReceipts",
  BILL_FORM: "billForm",
  PAYMENT_FORM: "paymentForm",
  MOVE_OUT: "moveOut",
  EDIT_ACCOUNT: "editAccount",
  TRANSFER_UNIT: "transferUnit",
  PAYMENT_PLAN: "paymentPlan",
  AUTO_PAY: "autoPay",
  FORWARDING_ADDRESS: "forwardingAddress",
  PLEDGE_ACCOUNT: "pledgeAccount",
  WINTER_CRISIS_HISTORY: "winterCrisisHistory",
  WINTER_CRISIS_PAYMENT: "winterCrisisPayment",
  MED_FORM_HISTORY: "medFormHistory",
  COMPLAINTS: "complaints",
  PAYMENT_BLOCKS: "paymentBlocks",
};

export function useDialogManager() {
  const [activeDialog, setActiveDialog] = useState(null);
  const [dialogData, setDialogData] = useState(null);

  const openDialog = useCallback((name, data = null) => {
    setActiveDialog(name);
    setDialogData(data);
  }, []);

  const closeDialog = useCallback(() => {
    setActiveDialog(null);
    setDialogData(null);
  }, []);

  const isOpen = useCallback((name) => activeDialog === name, [activeDialog]);

  return { activeDialog, dialogData, openDialog, closeDialog, isOpen };
}
